import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import { loadDomainTheme } from './styles/themeLoader';
import App from './App';

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Root element not found');
}

// Show a minimal loading state while the theme is being fetched,
// preventing a blank page during the async load.
rootElement.innerHTML = '<div id="app-loader" style="visibility:hidden"></div>';

loadDomainTheme()
    .catch((err: unknown) => {
        console.error('Failed to load domain theme, using defaults:', err);
    })
    .finally(() => {
        rootElement.innerHTML = '';

        ReactDOM.createRoot(rootElement).render(
            <React.StrictMode>
                <App />
            </React.StrictMode>
        );
    });